export const ADD_SUCCESS_MESSAGE = "ADD_SUCCESS_MESSAGE"
export const ADD_ERROR_MESSAGE = "ADD_ERROR_MESSAGE"
export const ADD_CMD_MESSAGE = "ADD_CMD_MESSAGE"
export const CLEAR_MESSAGES = "CLEAR_MESSAGES"